import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useNavigate } from "react-router-dom";
import { ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState, useEffect } from "react";

export default function AdminMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleToggleOpen = (event) => {
    if (open) setAnchorEl(null);
    else setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleClick = (route) => {
    handleClose();
    navigate(route);
  };

  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <Button
          sx={{ my: 2, color: "white", display: "flex" }}
          onClick={handleToggleOpen}
          endIcon={<ExpandMoreIcon />}
        >
          Admin
        </Button>
      </ClickAwayListener>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        sx={{ mt: 2 }}
      >
        <MenuItem onClick={() => handleClick("/files")}>Filer</MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/clientsarticles")}>
          Klientartiklar
        </MenuItem>
        <MenuItem onClick={() => handleClick("/clientsaccounts")}>
          Klientkonton
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/endcustomersarticles")}>
          Slutkundsartiklar
        </MenuItem>
        <MenuItem onClick={() => handleClick("/endcustomersaccounts")}>
          Slutkundskonton
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/endcustomerunplaced")}>
          Oplacerat
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/clientinvoicebundle")}>
          Fakturabuntar
        </MenuItem>
        <MenuItem onClick={() => handleClick("/clientpayments")}>
          Klientutbetalningar
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/endcustomerprinted")}>
          Fakturautskrifter
        </MenuItem>
        <MenuItem onClick={() => handleClick("/endcustomerpaymentbundles")}>
          Slutkundsinbetalningsbuntar
        </MenuItem>
      </Menu>
    </div>
  );
}
